<template>
    <div class="index">
        <div class="index-banner">
            <div class="index-banner-img-cover">
            </div>
            <div class="index-banner-title">
                Learn Mandarin Chinese <br> Every Day
            </div>
            <div class="index-banner-sub-title">
               Choose what to learn here
            </div>
            <div class="index-banner-button-card">
                <div class="index-banner-button">
                    <router-link to="/featuredCourse">
                        <el-button>
                            Featured Courses
                        </el-button>
                    </router-link>
                    <div class="index-banner-button-text">
                        Structured Chinese courses with study materials
                    </div>
                </div>
                <div class="index-banner-button">
                    <router-link to="/featuredCourse">
                        <el-button>
                            All Courses
                        </el-button>
                    </router-link>
                    <div class="index-banner-button-text">
                        Take the quizzes and download MP3/PDF free
                    </div>
                </div>
            </div>
        </div>
        <div class="index-header">
            <div class="index-header-card" v-for="icon in icons" :key="icon.key">
                <div class="index-header-content" >
                    <img :src="icon.name" />
                    <div class="index-header-content-text">
                        {{ icon.context }}K+
                    </div>
                </div>
            </div>
        </div>
        <!--
        <div class="index-divider">
            <img class="contact-us-content-logo-pc" src="../assets/img/ata-line.png">
            <img class="contact-us-content-logo-mobile" src="../assets/img/mobile/ata-line.png">
        </div>
        <div class="index-title">
            Meet Our Teachers
        </div>
        <div class="index-content">
            <div class="index-content-card" v-for="teacher in teachers" :key="teacher.key">
                <div class="index-content-banner" >
                    <img src="../assets/img/teacher-pic002.jpg" />
                </div>
                <div class="index-content-title" >
                    {{ teacher.name }}
                </div>
                <div class="index-content-description">
                    {{ teacher.description }}
                </div>
            </div>
        </div>
        <div class="index-divider">
            <img class="contact-us-content-logo-pc" src="../assets/img/ata-line.png">
            <img class="contact-us-content-logo-mobile" src="../assets/img/mobile/ata-line.png">
        </div>
        <div class="index-subtitle">
            Beginner to Advanced Chinese Courses
        </div>
        <div class="index-second-content">
            <div class="index-second-content-card">
                <div class="index-second-content-title">Online Learning</div>
                <div class="index-second-content-description">
                    Although we update new free lessons for stundents on our YouTube channel every week, we also provide the structured, comprehensive & easy online Chinese courses for those who want to learn Mandarin Chinese but have no or little background knowledge. Our courses are also designed for those who need to refresh their basic knowledge of Mandarin Chinese or build a solid foundation for learning Chinese language. Study Chinese with us now!
                </div>
                <div class="index-second-content-button">
                    <div class="index-second-content-button-item">
                        <router-link to="/featuredCourse">
                            <el-button round>Free Trial</el-button>
                        </router-link>
                    </div>
                    <div class="index-second-content-button-item">
                        <router-link to="/featuredCourse">
                            <el-button round>All Courses</el-button>
                        </router-link>
                    </div>
                </div>

            </div>
            <div class="index-second-content-card">
                <img src="../assets/img/courses-banner.jpg">
            </div>
        </div>
        <div class="index-third-content-background">
            <div class="index-third-content">
                <div class="index-third-content-title">
                    The Latest Lessons & Resources for Chinese Learning
                </div>
                <div class="index-third-content-courses">
                    <div class="index-third-content-courses-card" v-for="course in courses" :key="course.key" @click="handleRoute">
                        <div class="index-third-content-courses-card-thumbnail">
                            <img :src="course.thumbnail">
                        </div>
                        <div class="index-third-content-courses-card-content">
                            <div class="index-third-content-courses-card-title">
                                {{course.title}}
                            </div>
                            <div class="index-third-content-courses-card-description">
                                {{course.description}}
                            </div>
                             <div class="index-third-content-courses-card-info">
                                <div class="index-third-content-courses-card-team">
                                       {{course.author}}
                                </div>
                                <div class="index-third-content-courses-card-price">
                                    $ {{course.price}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <FooterBanner />
        -->
    </div>
</template>
<script>
    //import FooterBanner from './FooterBanner.vue';
    export default {
        name: "Index",
        components: {
            //FooterBanner
        },
        data() {
            return {
                icons:[
                    {
                        name: "./img/icon/icon-fb.png",
                        context: "285"
                    },
                    {
                        name: "./img/icon/icon-ig.png",
                        context: "11"
                    },
                    {
                        name: "./img/icon/icon-tt.png",
                        context: "2"
                    },
                    {
                        name: "./img/icon/icon-yt.png",
                        context: "220"
                    },

                ],
                teachers: [
                    {
                        name: "Ms. DengDeng",
                        description: "Hi, I’m Dengdeng. I majored in teaching Chinese as a second language in university and got an international Chinese teacher certificate. After graduation, I worked as a Chinese teacher in a college in Thailand. I have been teaching Chinese for 6 years. In Everyday Chinese team, I’m mainly responsible for course design and review. It’s a great pleasure to meet you here and help you learn Chinese language!"
                    },
                    {
                        name: "Ms. Joyce",
                        description: "Hello! I’m Joyce. I’ve been teaching Chinese for 9 years. My students are from different parts of the world with diverse backgrounds and ages. Among them, the youngest is 6 and the oldest are in their seventies. My strength is to teach from the learner’s perspective and cater to their needs with the easiest to understand language. My goal is to make your every class with me a fruitful one!"
                    },
                    {
                        name: "Ms. Crystal",
                        description: "Hi there, I’m Crystal. For the past 3 years I’ve been teaching Mandarin online to students adults at all levels, beginners to advanced. As an English learner, I know how scary it can be learning and practicing languages so i make my lessons fun, clear and easy to understand. I tailor my lessons to students who want to improve their Chinese speaking skills. If you want to speak Mandarin naturally, feel free to join my spoken course!"
                    },
                ],
                courses: [
                    {
                        title: "Beginner Chinese for HSK 1 (Full Lessons)",
                        description: "The structured, comprehensive and easy Chinese lessons for beginners",
                        author: "Learning Hub Team",
                        price: "78",
                        thumbnail: require("../assets/img/courses-image001.jpg")
                    },
                    {
                        title: "Elementary Chinese for HSK 2 (Full Lessons)",
                        description: "The structured, comprehensive and easy Mandarin Chinese lessons - Pass HSK 2 guaranteed ",
                        author: "Learning Hub Team 2",
                        price: "79",
                        thumbnail: require("../assets/img/courses-image002.jpg")
                    },
                    {
                        title: "Spoken Chinese Course",
                        description: "Need to improve your spoken Chinese? Take your Chinese speaking skills to the next level!",
                        author: "Learning Hub Team 3",
                        price: "80",
                        thumbnail: require("../assets/img/courses-image003.jpg")
                    },
                    {
                        title: "Beginner Chinese for HSK 1 (Full Lessons)",
                        description: "The structured, comprehensive and easy Chinese lessons for beginners",
                        author: "Learning Hub Team",
                        price: "78",
                        thumbnail: require("../assets/img/courses-image001.jpg")
                    },
                    {
                        title: "Elementary Chinese for HSK 2 (Full Lessons)",
                        description: "The structured, comprehensive and easy Mandarin Chinese lessons - Pass HSK 2 guaranteed ",
                        author: "Learning Hub Team 2",
                        price: "79",
                        thumbnail: require("../assets/img/courses-image002.jpg")
                    },
                    {
                        title: "Spoken Chinese Course",
                        description: "Need to improve your spoken Chinese? Take your Chinese speaking skills to the next level!",
                        author: "Learning Hub Team 3",
                        price: "80",
                        thumbnail: require("../assets/img/courses-image003.jpg")
                    },
                ],
                data: {},
            };
        },
        mounted() {
            this.init();
        },
        methods: {
            init() {

            },
            handleRoute(){
                this.$router.push({
                    path: "/tutorial"
                })
            },
        },
    };
</script>
<style lang='scss' type='text/css'>
    @import "../styles/pc/Index.scss";
    @import "../styles/mobile/Index.scss";
</style>